<template>
  <div :id="id" style="min-height: 300px"></div>
</template>


<script>
import { Chart } from "frappe-charts/dist/frappe-charts.min.esm";
import statisticClient from "@/api/central/statistics";
import _keys from "lodash/keys";
import _values from "lodash/values";
import _map from "lodash/map";
import numeral from "numeral";
import dayjs from "dayjs";

export default {
  props: {
    dateFrom: {
      required: true,
      type: String
    },
    dateTo: {
      required: true,
      type: String
    },
    interval: {
      required: true,
      type: String
    },
    events: {
      required: false,
      type: String | Number,
      default: ""
    }
  },

  data() {
    return {
      id: null,
      chart: {},
      settings: {
        labels: [],
        datasets: [
          {
            name: "Ticket Umsatz",
            type: "line",
            values: []
          }
        ]
      }
    };
  },

  async mounted() {
    this.id = `chart-${this._uid}`;
    this.$watch(() => this.$props, this.reloadChart, { deep: true });

    await this.loadRevenueStatistics();
    this.startChart();
  },

  methods: {
    startChart() {
      this.chart = new Chart(`#${this.id}`, {
        // or a DOM element,
        data: this.settings,
        type: "line", // or 'bar', 'line', 'scatter', 'pie', 'percentage'
        height: 300,
        colors: ["#7cd6fd", "#743ee2"],
        axisOptions: {
          xIsSeries: true
        },
        tooltipOptions: {
          formatTooltipY: d => numeral(d).format("0,0[.]00 $")
        }
      });
    },

    dateFormat(d) {
      switch (this.interval) {
        case "hour":
          return dayjs(d).format("dd, DD.MM.YYYY HH:00");
        case "day":
          return dayjs(d).format("dd, DD.MM.YYYY");
        case "month":
          return dayjs(d).format("MMMM YYYY");
        case "year":
          return dayjs(d).format("YYYY");
      }
    },

    async loadRevenueStatistics() {
      let { data } = await statisticClient.revenue(
        this.dateFrom,
        this.dateTo,
        this.interval,
        this.events
      );

      this.settings.labels = _map(_keys(data.data), item =>
        this.dateFormat(item)
      );
      this.settings.datasets[0].values = _values(data.data);
    },

    async reloadChart() {
      await this.loadRevenueStatistics();
      this.chart.update(this.settings);
    }
  }
};
</script>
